// TODO §BACKEND: GET /api/mentor-applications/:userId
// TODO §BACKEND: POST /api/mentor-applications { userId, status, submittedAt }
// TODO §BACKEND: PATCH /api/mentor-applications/:userId { status, rejectedAt }

export function getMentorAppStatus(userId) {
  try {
    return JSON.parse(localStorage.getItem(`db_mentor_app_${userId}`)) || null;
  } catch {
    return null;
  }
}

export function setMentorAppStatus(userId, data) {
  try {
    localStorage.setItem(`db_mentor_app_${userId}`, JSON.stringify(data));
  } catch {}
}

export function canReapply(app) {
  if (!app || app.status !== 'rejected') return false;
  return Date.now() - (app.rejectedAt || 0) >= 30 * 24 * 60 * 60 * 1000;
}

export function reapplyUnlockDate(app) {
  const d = new Date((app?.rejectedAt || 0) + 30 * 24 * 60 * 60 * 1000);
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function hasMentorSeenTour(userId) {
  try {
    return !!localStorage.getItem(`db_mentor_tour_${userId}`);
  } catch {
    return false;
  }
}

export function markMentorTourSeen(userId) {
  try {
    localStorage.setItem(`db_mentor_tour_${userId}`, '1');
  } catch {}
}
